import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useLoadPlatformDataAndCurrentUser } from "./features/frontend/frontendSlice";
import AppV1 from "./components-v1/AppV1";
import AppV2 from "./components-v2/AppV2";
import MarketingApp from "./components-v2/marketing/MarketingApp";
import { APP_SURFACES, getAppSurface } from "./appRouting";

const AppWrapper = () => {
  const { platformData, allowMarketingSurface } = useSelector(state => state.frontend);
  const { pathname } = useLocation();
  useLoadPlatformDataAndCurrentUser();

  const surface = getAppSurface(
    platformData,
    pathname,
    allowMarketingSurface,
    window.location.hostname
  );
  if (!surface) return null;
  if (surface === APP_SURFACES.MARKETING) return <MarketingApp />;
  if (surface === APP_SURFACES.V1) return <AppV1 />;
  return <AppV2 />;
};

export default AppWrapper;
